import {createRouter, createWebHashHistory, RouteRecordRaw} from 'vue-router'
import Home from '../views/Home.vue'
import {PageGroup} from "@/types/dto";
import {ElMessageBox} from "element-plus";
import {pageStore} from "@/store/pageStore";
//
// const routes1: Array<RouteRecordRaw> = [
//     {
//         path: '/',
//         redirect: '/dashboard'
//     },
//     {
//         path: "/",
//         name: "Home",
//         component: Home,
//         children: [
//             {
//                 path: "/dashboard",
//                 name: "dashboard",
//                 meta: {
//                     title: '系统首页'
//                 },
//                 component: () => import (
//                     /* webpackChunkName: "dashboard" */
//                     "../views/Dashboard.vue")
//             }, {
//                 path: "/system/staff/staff.html",
//                 name: "SystemStaff",
//                 meta: {
//                     title: '账户管理-系统级别'
//                 },
//                 component: () => import (  "@/views/system/staff/staff.vue")
//             }, {
//                 path: "/user/index.html",
//                 name: "User",
//                 meta: {
//                     title: '账户管理'
//                 },
//                 component: () => import (  "@/views/user/index.vue")
//             }, {
//                 path: "/organization/index.html",
//                 name: "Organization",
//                 meta: {
//                     title: '组织架构'
//                 },
//                 component: () => import (  "../views/organization/index.vue")
//             }, {
//                 path: "/authStaffOrg/index.html",
//                 name: "AuthStaffOrg",
//                 meta: {
//                     title: '组织授权'
//                 },
//                 component: () => import (  "../views/authStaffOrg/index.vue")
//             }, {
//                 path: "/workTime/index.html",
//                 name: "WorkTimeIndex",
//                 meta: {
//                     title: '上班时间管理'
//                 },
//                 component: () => import (  "../views/workTime/index.vue")
//             }, {
//                 path: "/role/index.html",
//                 name: "Role",
//                 meta: {
//                     title: '角色管理-电销级别'
//                 },
//                 component: () => import (  "../views/teljob/Role/Role.vue")
//             }, {
//                 path: "/customer/my.html",
//                 name: "MyCustomer",
//                 meta: {
//                     title: '我的客户'
//                 },
//                 component: () => import (  "../views/customer/my.vue")
//             }, {
//                 path: "/customer/import/index.html",
//                 name: "ImportCustomer",
//                 meta: {
//                     title: '导入客户'
//                 },
//                 component: () => import (  "../views/customer/import/index.vue")
//             }, {
//                 path: "/customer/distribute.html",
//                 name: "DistributeCustomer",
//                 meta: {
//                     title: '分配客户'
//                 },
//                 component: () => import (  "../views/customer/DistributeCustomer.vue")
//             }, {
//                 path: "/customer/public.html",
//                 name: "PublicCustomer",
//                 meta: {
//                     title: '公共池'
//                 },
//                 component: () => import (  "../views/customer/public.vue")
//             }, {
//                 path: "/customer/publicIntention.html",
//                 name: "PublicCustomerIntention",
//                 meta: {
//                     title: '公共池-意向',
//                     intention: true
//                 },
//                 component: () => import ("../views/customer/publicIntention.vue")
//             }, {
//                 path: "/customer/all.html",
//                 name: "AllCustomer",
//                 meta: {
//                     title: '全部客户'
//                 },
//                 component: () => import (  "../views/customer/all.vue")
//             }, {
//                 path: "/customer/archives.html",
//                 name: "CustomerArchives",
//                 meta: {
//                     title: '客户档案录入'
//                 },
//                 component: () => import (  "../views/customer/archives.vue")
//             }, {
//                 path: "/customer/order.html",
//                 name: "OrderCustomer",
//                 meta: {
//                     title: '已成单'
//                 },
//                 component: () => import (  "../views/customer/order.vue")
//             }, {
//                 path: "/customer/tag.html",
//                 name: "TagCustomer",
//                 meta: {
//                     title: '标记客户'
//                 },
//                 component: () => import (  "../views/customer/tag.vue")
//             }, {
//                 path: "/customer/disable.html",
//                 name: "DisableCustomer",
//                 meta: {
//                     title: '回收站'
//                 },
//                 component: () => import (  "../views/customer/disable.vue")
//             }, {
//                 path: "/intentionCount/staff.html",
//                 name: "CountByStaff",
//                 meta: {
//                     title: '员工意向统计'
//                 },
//                 component: () => import (  "../views/intentionCount/staff.vue")
//             }, {
//                 path: "/intentionCount/customer.html",
//                 name: "CustomerCountGroup.vue",
//                 meta: {
//                     title: '客户意向统计'
//                 },
//                 component: () => import (  "../views/intentionCount/customer.vue")
//             }, {
//                 path: "/customer/org.html",
//                 name: "CustomerCount",
//                 meta: {
//                     title: '客户统计'
//                 },
//                 component: () => import (  "../views/customer/org.vue")
//             }, {
//                 path: "/customerDocTmp/index.html",
//                 name: "CustomerDocTmp",
//                 meta: {
//                     title: '客户跟单'
//                 },
//                 component: () => import (  "../views/customerDoc/customerDocTmp.vue")
//             }, {
//                 path: "/intentionTmp/index.html",
//                 name: "IntentionTmp",
//                 meta: {
//                     title: '意向配置'
//                 },
//                 component: () => import (  "../views/intention/intentionTmp.vue")
//             }, {
//                 path: "/setting/index.html",
//                 name: "Setting",
//                 meta: {
//                     title: '基础设置'
//                 },
//                 component: () => import (  "../views/setting/index.vue")
//             }, {
//                 path: "/form/index.html",
//                 name: "Form",
//                 meta: {
//                     title: '表单'
//                 },
//                 component: () => import (  "../views/form/index.vue")
//             }, {
//                 path: "/formTemplate/index.html",
//                 name: "FormTemplate",
//                 meta: {
//                     title: '表单模板'
//                 },
//                 component: () => import (  "../views/formTemplate/index.vue")
//             }, {
//                 path: "/checkConfig/index.html",
//                 name: "CheckConfig",
//                 meta: {
//                     title: '考核配置'
//                 },
//                 component: () => import (  "../views/checkConfig/index.vue")
//             }, {
//                 path: "/count/index.html",
//                 name: "RecordCount",
//                 meta: {
//                     title: '通话统计'
//                 },
//                 component: () => import (  "../views/count/index.vue")
//             }, {
//                 path: "/checkCount/index.html",
//                 name: "CheckCount",
//                 meta: {
//                     title: '考核统计'
//                 },
//                 component: () => import (  "../views/checkCount/index.vue")
//             }, {
//                 path: "/system/role.html",
//                 name: "SystemRole",
//                 meta: {
//                     // TODO
//                     title: '角色设置'
//                 },
//                 component: () => import (  "../views/system/Role/Role.vue")
//             }, {
//                 path: "/system/auth/index.html",
//                 name: "SystemAuth",
//                 meta: {
//                     title: '权限设置'
//                 },
//                 component: () => import (  "@/views/system/auth/index.vue")
//             }, {
//                 path: "/system/page.html",
//                 name: "SystemPage",
//                 meta: {
//                     // TODO
//                     title: '页面权限设置'
//                 },
//                 component: () => import (  "@/views/system/page/index.vue")
//             }, {
//                 path: "/risk/organization/index.html",
//                 name: "riskOrganization",
//                 meta: {
//                     title: '风控组织管理'
//                 },
//                 component: () => import (  "@/views/risk/organization/index.vue")
//             }, {
//                 path: "/risk/customer/index.html",
//                 name: "riskCustomer",
//                 meta: {
//                     title: '客户订单'
//                 },
//                 component: () => import (  "../views/risk/customer/index.vue")
//             }, {
//                 path: "/logistics/projectTmp/index.html",
//                 name: "logisticsProjectTmp",
//                 meta: {
//                     title: '客户模板管理'
//                 },
//                 component: () => import (  "@/views/logistics/projectTmp/index.vue")
//                 //    component:()=>import("@/views/customerDoc/customerDocTmp.vue")
//             }, {
//                 path: "/logistics/organization/index.html",
//                 name: "logisticsOrganization",
//                 meta: {
//                     title: '后勤组织管理'
//                 },
//                 component: () => import (  "@/views/logistics/organization/index.vue")
//             }, {
//                 path: "/logistics/archives.html",
//                 name: "logisticsArchives",
//                 meta: {
//                     // TODO
//                     title: '客户档案管理'
//                 },
//                 component: () => import (  "../views/logistics/archives/index/index.vue")
//             }, {
//                 path: "/logistics/order.html",
//                 name: "logisticsOrder",
//                 meta: {
//                     // todo
//                     title: '做单客户'
//                 },
//                 component: () => import (  "../views/logistics/order/index.vue")
//             }, {
//                 path: "/logistics/productSummary/index.html",
//                 name: "productSummary",
//                 meta: {
//                     title: '产品大全'
//                 },
//                 component: () => import (  "@/views/logistics/productSummary/index.vue")
//             }, {
//                 path: "/serve/product/index.html",
//                 name: "serveProduct",
//                 meta: {
//                     title: '产品推荐'
//                 },
//                 component: () => import (  "../views/serve/product/index.vue")
//             }, {
//                 path: "/account/association.html",
//                 name: "accountAssociation",
//                 meta: {
//                     title: '账户关联'
//                 },
//                 component: () => import (  "../views/account/association.vue")
//             }, {
//                 path: "/after/customer/index.html",
//                 name: "afterCustomer",
//                 meta: {
//                     title: '客户管理'
//                 },
//                 component: () => import (  "../views/after/customer/index.vue")
//             }, {
//                 path: "/wechat/userInfo.html",
//                 name: "wechatUserInfo",
//                 meta: {
//                     title: '微信客户管理'
//                 },
//                 component: () => import (  "../views/wechat/userInfo.vue")
//             }, {
//                 path: "/autoShare/index.html",
//                 name: "autoShareIndex",
//                 meta: {
//                     title: '自动分享配置'
//                 },
//                 component: () => import (  "../views/autoShare/index.vue")
//             }, {
//                 path: "/autoAllocConfig/index.html",
//                 name: "autoAllocConfigIndex",
//                 meta: {
//                     title: '自动分配配置'
//                 },
//                 component: () => import (  "@/views/autoAllocConfig/index.vue")
//             }, {
//                 path: "/attendance.html",
//                 name: "Attendance",
//                 meta: {
//                     // todo
//                     title: '考勤管理'
//                 },
//                 component: () => import (  "../views/attendance/Attendance.vue")
//             }, {
//                 path: "/reward.html",
//                 name: "Reward",
//                 meta: {
//                     title: '奖励扣款'
//                 },
//                 component: () => import (  "../views/reward/index.vue")
//             }, {
//                 path: "/riskOrder/index.html",
//                 name: "RiskOrder",
//                 meta: {
//                     title: '客户单'
//                 },
//                 component: () => import (  "../views/riskOrder/index.vue")
//             }, {
//                 path: "/riskOrder/charge.html",
//                 name: "RiskOrderCharge",
//                 meta: {
//                     title: '提成列表'
//                 },
//                 component: () => import (  "../views/riskOrder/charge.vue")
//             }, {
//                 path: "/commission/index.html",
//                 name: "CommissionConfig",
//                 meta: {
//                     title: '提成配置'
//                 },
//                 component: () => import (  "@/views/commission/index.vue")
//             }, {
//                 path: "/salary/index.html",
//                 name: "SalaryIndex",
//                 meta: {
//                     title: '薪资表'
//                 },
//                 component: () => import (  "../views/salary/index.vue")
//             }, {
//                 path: "/audit/index.html",
//                 name: "AuditIndex",
//                 meta: {
//                     title: '审核配置'
//                 },
//                 component: () => import (  "../views/audit/index.vue")
//             }, {
//                 path: "/mobile/index.html",
//                 name: "MobileIndex",
//                 meta: {
//                     title: '手机管理'
//                 },
//                 component: () => import (  "../views/mobile/index.vue")
//             }, {
//                 path: "/dept/index.html",
//                 name: "DeptIndex",
//                 meta: {
//                     title: '部门管理'
//                 },
//                 component: () => import (  "../views/dept/index.vue")
//             }
//         ]
//     }, {
//         path: "/login",
//         name: "Login",
//         meta: {
//             title: '登录'
//         },
//         component: () => import ("../views/Login/Login.vue")
//     }
// ]

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/dashboard'
    }, {
        path: "/login",
        name: "Login",
        meta: {
            title: '登录'
        },
        component: () => import ("../views/Login/Login.vue")
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})


router.beforeEach(async (to, from, next) => {
    document.title = `${to.meta.title} | 厦门井雨企业管理咨询`;
    const token = sessionStorage.getItem("token");
    console.log(to);

    if (!token && to.path !== '/login') {
        next('/login');
    } else if (to.matched.length == 0) {
        console.log("init router")
        // next("/")
        if (pageStore().isInit) {
            console.log("已经加载过了")
            ElMessageBox.alert("页面信息加载失败,请刷新页面重试", "错误").then(() => {
            });
            next("/login")
            return
        }
        try {
            const data = await pageStore().queryPage();
            // 加入路由
            reloadRouter()
            addRouter(data)
            console.log("add routers")
            next(to.path)
        } catch (err) {
            ElMessageBox.alert("页面信息加载失败,请刷新页面重试", "错误").then(() => {
            });
            next(false)
        }
    } else {
        next();
    }
});


export default router

/**
 * 重置路由
 */
export function reloadRouter() {
    router.clearRoutes()
    routes.forEach(item => {
        router.addRoute(item)
    })
}

export function addRouter(pageGroupList: PageGroup[]) {
    let routerList = [
        {
            path: "/dashboard",
            name: "dashboard",
            meta: {
                title: '系统首页'
            },
            component: () => import (  "../views/Dashboard.vue")
        }
    ]
    for (let pageGroup of pageGroupList) {
        const {page, title, itemList} = pageGroup
        if (itemList.length == 0) {
            routerList.push({
                path: page,
                name: page,
                meta: {
                    title: title
                },
                component: () => import((`../views${page.replaceAll("html", "vue")}`))
            })
        } else {
            for (let pageItem of itemList) {
                const {page, title} = pageItem;
                routerList.push({
                    path: page,
                    name: page,
                    meta: {
                        title: title
                    },
                    component: () => import((`../views${page.replaceAll("html", "vue")}`))
                })
            }
        }
    }
    router.addRoute({
        path: "/",
        name: "Home",
        component: Home,
        children: routerList
    })
    console.log(router.getRoutes())
}
